// extracted by mini-css-extract-plugin
export var body = "bottomIconList-module--body--Xuw3G";
export var heading = "bottomIconList-module--heading--VFv0Y";
export var icon = "bottomIconList-module--icon--lrPvo";
export var iconContainer = "bottomIconList-module--iconContainer--Gub5e";
export var list = "bottomIconList-module--list--BC4Yi";
export var listItem = "bottomIconList-module--listItem--qZ1G3";
export var show = "bottomIconList-module--show--yHFDK";
export var text = "bottomIconList-module--text--P8GMb";